// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.speakerContainer {
  padding: 15px;
}

.speakerContainer .group {
  display: flex;
  flex-direction: column;
  margin: 10px 0;
}

.speakerContainer .group .picture-input {
  display: flex;
  flex-direction: column;
}

.speakerContainer .group .picture-value {
  margin: auto;
  padding-top: 10px;
}

.speakerContainer .group .picture-value img {
  width: 64px;
  height: 64px;
  margin: 5px 0;
}

.speakerContainer .group label {
  margin-bottom: 5px;
}

.speakerContainer .group input {
  padding: 0.5em;
}

.speakerContainer .group fieldset {
  border: none;
  padding: 0;
  margin: 0;
}

.speakerContainer .group fieldset legend{
  margin-bottom: 5px;
}

.speakerContainer .group .genders,
.speakerContainer .group .colors {
  display: flex;
}

.speakerContainer .group .gender,
.speakerContainer .group .color {
  margin-right: 15px;
}

.speakerContainer .group input[type=radio] {
  margin-right: 5px;
}

.speakerContainer .group .color input{
    vertical-align: text-top;
}

.speakerContainer .group .color img {
  height: 20px;
}

.speakerContainer .group.error {
  label,
  p {
    color: red;
  }

  input {
    border: 1px solid red;
  }

  p{
    font-size: 80%;
  }
}`, "",{"version":3,"sources":["webpack://./src/applications/appcode/appcomponents/speakerslist/speakerform/speakerform.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;AACf;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;;IAEE,UAAU;EACZ;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,cAAc;EAChB;AACF","sourcesContent":[".speakerContainer {\r\n  padding: 15px;\r\n}\r\n\r\n.speakerContainer .group {\r\n  display: flex;\r\n  flex-direction: column;\r\n  margin: 10px 0;\r\n}\r\n\r\n.speakerContainer .group .picture-input {\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.speakerContainer .group .picture-value {\r\n  margin: auto;\r\n  padding-top: 10px;\r\n}\r\n\r\n.speakerContainer .group .picture-value img {\r\n  width: 64px;\r\n  height: 64px;\r\n  margin: 5px 0;\r\n}\r\n\r\n.speakerContainer .group label {\r\n  margin-bottom: 5px;\r\n}\r\n\r\n.speakerContainer .group input {\r\n  padding: 0.5em;\r\n}\r\n\r\n.speakerContainer .group fieldset {\r\n  border: none;\r\n  padding: 0;\r\n  margin: 0;\r\n}\r\n\r\n.speakerContainer .group fieldset legend{\r\n  margin-bottom: 5px;\r\n}\r\n\r\n.speakerContainer .group .genders,\r\n.speakerContainer .group .colors {\r\n  display: flex;\r\n}\r\n\r\n.speakerContainer .group .gender,\r\n.speakerContainer .group .color {\r\n  margin-right: 15px;\r\n}\r\n\r\n.speakerContainer .group input[type=radio] {\r\n  margin-right: 5px;\r\n}\r\n\r\n.speakerContainer .group .color input{\r\n    vertical-align: text-top;\r\n}\r\n\r\n.speakerContainer .group .color img {\r\n  height: 20px;\r\n}\r\n\r\n.speakerContainer .group.error {\r\n  label,\r\n  p {\r\n    color: red;\r\n  }\r\n\r\n  input {\r\n    border: 1px solid red;\r\n  }\r\n\r\n  p{\r\n    font-size: 80%;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
